module.exports = __webpack_public_path__ + "static/media/striped_bar_packShip_tall.975cb2fc.svg";